import React from 'react';
import { Button, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

const MezoForm = (props) => {
    const { formMezoNev, formMezoErtek, handleInputChange, addMetaAdat } = props;

    const mezoInputs = () => {
        console.log(formMezoErtek, formMezoNev)
        return (
            <React.Fragment>
                <div className="col-md-3 col-sm-6">
                    <Label for='formMezoNev'>{'Mező neve: '}</Label>
                    <Input
                        name="formMezoNev"
                        id="formMezoNev"
                        value={formMezoNev}
                        autoComplete="new-password"
                        onChange={handleInputChange}
                        type="text"
                        maxLength="30"
                    />
                </div>
                <div className="col-md-3 col-sm-6">
                    <Label for='formMezoErtek'>{'Mező értéke:'}</Label>
                    <Input
                        name="formMezoErtek"
                        id="formMezoErtek"
                        value={formMezoErtek}
                        onChange={handleInputChange}
                        type="text"
                        maxLength="200"
                    />
                </div>
                <div className="col-md-3 col-sm-6">
                    <Button color="primary" onClick={() => addMetaAdat(formMezoNev, formMezoErtek)} style={{ marginTop: 29 }}>Hozzáadás</Button>
                </div>
            </React.Fragment>
        );
    }


  return (
    <div className="row">
        {mezoInputs()}
    </div>
  )
}

MezoForm.propTypes = {
    formMezoNev: PropTypes.string.isRequired,
    formMezoErtek: PropTypes.any.isRequired,
    handleInputChange: PropTypes.func.isRequired,
    addMetaAdat: PropTypes.func.isRequired
}

export default MezoForm